import React__default from 'react';
import styled from 'styled-components';
import sx from '../../sx.js';
import GradientText from '../GradientText/GradientText.js';
import Text from '../Text/Text.js';
import { get } from '../../constants.js';
import Box from '../Box/Box.js';

/**
 * The FooterTitle component provides an interface to render title announcing the footer that allows for providing a solid color,
 * the text you'd like to render as a clipped gradient,
 * a gradientTo value, a gradientFrom value, and a fallBackColor prop to render gradient text effects in browsers that don't support background-clip.
 */
const FooterTitle = ({
  sx: sxProp,
  solidText,
  gradientText,
  solidTextColor = '#FFFFFF',
  gradientFrom = '#F96C2C',
  gradientTo = '#F9D95D',
  fallbackColor = '#0098eb'
}) => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Outer, null, /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(StyledText, {
    as: "p",
    style: {
      '--color': solidTextColor
    }
  }, solidText, "\xA0"), /*#__PURE__*/React__default.createElement(GradientText, {
    as: "p",
    gradientTo: gradientTo,
    gradientFrom: gradientFrom,
    sx: {
      display: 'inline'
    },
    fallbackColor: fallbackColor
  }, gradientText))));
};
const StyledText = styled(Text).withConfig({
  displayName: "FooterTitle__StyledText",
  componentId: "sc-18r9emc-0"
})(["display:inline;font-weight:800;color:var(--color);", ""], sx);
const Wrapper = styled.span.withConfig({
  displayName: "FooterTitle__Wrapper",
  componentId: "sc-18r9emc-1"
})(["flex-direction:row;justify-content:space-between;align-items:flex-start;width:100%;font-size:1.5rem;line-height:1;font-weight:700;font-family:", ";letter-spacing:-0.025em;text-align:center;max-width:356px;@media (min-width:", "){max-width:456px;font-size:2rem;max-width:546px;}@media (min-width:", "){max-width:630px;font-size:2.85rem;}"], get('fonts.normal'), get('breakpoints.0'), get('breakpoints.1'));
const Outer = styled(Box).withConfig({
  displayName: "FooterTitle__Outer",
  componentId: "sc-18r9emc-2"
})(["display:flex;flex-direction:column;margin-top:64px;@media (min-width:", "){text-align:center;max-width:630px;}", ""], get('breakpoints.1'), sx);
FooterTitle.displayName = 'FooterTitle';
var FooterTitle$1 = FooterTitle;

export { FooterTitle$1 as default };
